export const videos = [
   {
		src: `${process.env.PUBLIC_URL}/assets/galeri/video/1.jpg`,
		width: 1,
		height: 1,
      links: 'https://www.youtube.com/embed/-rK1w4_80CA'
	},
	{
		src: `${process.env.PUBLIC_URL}/assets/galeri/video/2.jpg`,
		width: 1,
		height: 1,
      links: 'https://www.youtube.com/embed/4_ffNx6uMck'
	},
	{
		src: `${process.env.PUBLIC_URL}/assets/galeri/video/3.jpg`,
		width: 1,
		height: 1,
      links: 'https://www.youtube.com/embed/ovn5UU2eoiI'
	},
	{
		src: `${process.env.PUBLIC_URL}/assets/galeri/video/4.jpg`,
		width: 1,
		height: 1,
      links: 'https://www.youtube.com/embed/4sc0bCM3l4w'
	},
	{
		src: `${process.env.PUBLIC_URL}/assets/galeri/video/5.jpg`,
		width: 1,
		height: 1,
      links: 'https://www.youtube.com/embed/e5ikaXGX_M0'
	},
	{
		src: `${process.env.PUBLIC_URL}/assets/galeri/video/6.jpg`,
		width: 1,
		height: 1,
      links: 'https://www.youtube.com/embed/a52XL_Up1WA'
	},
	{
		src: `${process.env.PUBLIC_URL}/assets/galeri/video/7.jpg`,
		width: 1,
		height: 1,
      links: 'https://www.youtube.com/embed/KGV-_6O5Zbo'
	},
	{
		src: `${process.env.PUBLIC_URL}/assets/galeri/video/8.jpg`,
		width: 1,
		height: 1,
      links: 'https://www.youtube.com/embed/SJ9GCuu-riw'
	},
	{
		src: `${process.env.PUBLIC_URL}/assets/galeri/video/9.jpg`,
		width: 1,
		height: 1,
      links: 'https://www.youtube.com/embed/vDoq1VY25K0'
	},
	{
		src: `${process.env.PUBLIC_URL}/assets/galeri/video/10.jpg`,
		width: 1,
		height: 1,
      links: 'https://www.youtube.com/embed/OPDf-zdfB_M'
	},
	{
		src: `${process.env.PUBLIC_URL}/assets/galeri/video/11.jpg`,
		width: 1,
		height: 1,
      links: 'https://www.youtube.com/embed/wvs6NfVC9O4'
	},
	{
		src: `${process.env.PUBLIC_URL}/assets/galeri/video/12.jpg`,
		width: 1,
		height: 1,
      links: 'https://www.youtube.com/embed/eiHfJXQSnkY'
	},
]